import { aboutImages } from '../../../utils/images';
import OptimizedImage from '../../../components/base/OptimizedImage';

export default function CompanyIntroduction() {
  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="space-y-10">
              <div>
                <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
                  Our Story
                </div>
                <h2 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
                  About{' '}
                  <span className="font-normal">
                    Musheng
                  </span>
                </h2>
              </div>
              
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed font-light">
                <p>
                  Musheng Apparel Trading Co., Ltd., based in Hong Kong, has its roots in leather tanning and dyeing. Over the years, we have evolved into a leading apparel manufacturer that integrates garment production, product development, leather processing, and dyeing into a comprehensive solution.
                </p>
                <p>
                  We specialize in leather garments, shearling, PU, faux fur, down jackets, and outerwear, serving both premium fashion labels and mass-market retailers. With a strong international supply chain and years of experience, Musheng provides quality, innovation, and reliability to global clients.
                </p>
              </div>
            </div>
          </div>
          
          <div className="order-1 lg:order-2 relative">
            <div className="relative">
              <OptimizedImage
                src={aboutImages.craftsman}
                webpSrc={aboutImages.craftsmanWebp}
                alt="Musheng Manufacturing"
                className="rounded-none object-cover w-full lg:w-[110%] h-[400px] object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
